import axiosClient from "axios";
import { CONFIG } from "../environment";
import {
  SET_AUTH_REFRESH_TOKEN,
  SET_AUTH_TOKEN,
  SET_ERROR_MESSAGE,
  SET_SERVICE_LOADER,
} from "../store/constants";
import { store } from "../store";
import _sodium from "libsodium-wrappers";
import base64 from "base-64";
import { Buffer } from "buffer";
import AuthService from "./auth.service";
let encryptionNotReqd = true;
let isRefreshing = false;

const refreshAndRetryQueue = [];

const Axios = axiosClient.create({
  baseURL: CONFIG.SERVICE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

let activeRequests = 0;

Axios.interceptors.request.use(
  async (config) => {
    const { auth, app } = store.getState();
    const interceptedConfig = config;

    if (CONFIG.ENABLE_TENENT) {
      interceptedConfig.headers["X-TenantID"] = "tenant2";
    }

    if (
      auth.authToken !== null &&
      !interceptedConfig.url.endsWith("public/refreshtoken")
    ) {
      interceptedConfig.headers.Authorization = `Bearer ${auth.authToken}`;
    }
    if (CONFIG.ENCRYPT_ENABLE) {
      interceptedConfig.headers["X-Client-Id"] = base64.encode(app?.deviceId);
    }

    if (interceptedConfig.method === "post") {
      interceptedConfig.data.language = app.language;
      interceptedConfig.data.channelType = "WEB";
      interceptedConfig.data.ipAddress = "0.0.0.0";
      interceptedConfig.data.mode = app?.mode;

      if (
        Object.keys(app.loginDetails).length > 0 &&
        !interceptedConfig.url.endsWith("public/ib/login/verify") &&
        !interceptedConfig.url.endsWith("public/ib/login/confirm") &&
        !interceptedConfig.url.endsWith("public/register/verify") &&
        !interceptedConfig.url.endsWith("public/register/usernamecheck")
      ) {
        interceptedConfig.data.userName = app?.loginDetails?.userName;
      }
    }
    activeRequests++;
    store.dispatch({
      type: SET_SERVICE_LOADER,
      payload: true,
    });

    if (CONFIG.ENCRYPT_ENABLE) {
      if (app?.sharedKey == "null") {
        return;
      }
      if (
        (interceptedConfig.data &&
          interceptedConfig.data.encryptionNotReqd === true) ||
        interceptedConfig.url.endsWith("fileUpload/initVerify") ||
        interceptedConfig.url.endsWith("fileUpload/initConfirm") ||
        interceptedConfig.url.endsWith(
          "ftmgmt/fundtransfer/internationalFtFileUpload"
        )
      ) {
        encryptionNotReqd = true;
        return interceptedConfig;
      } else {
        try {
          await _sodium.ready;
          const Sodium = _sodium;
          encryptionNotReqd = false;
          const nonce = await Sodium.randombytes_buf(24);
          let msg = JSON.stringify(interceptedConfig.data);
          const cipherText = await Sodium.crypto_box_easy_afternm(
            msg,
            nonce,
            app?.sharedKey,
            "uint8array"
          );
          const buffer = Buffer.from(cipherText, "base64");
          const bufString = buffer.toString("hex");
          console.log(interceptedConfig);
          interceptedConfig.data = {
            message: bufString,
            clientId: base64.encode(app?.deviceId),
            nonce: Sodium.to_base64(nonce, Sodium.base64_variants.ORIGINAL),
          };
          return interceptedConfig;
        } catch (error) {
          console.log(error);
        }
      }
    } else {
      return interceptedConfig;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

Axios.interceptors.response.use(
  async (response) => {
    try {
      activeRequests = Math.max(0, activeRequests - 1);
      store.dispatch({ type: SET_SERVICE_LOADER, payload: activeRequests > 0 });

      const { app } = store.getState();
      if (response?.headers?.access_token) {
        store.dispatch({
          type: SET_AUTH_TOKEN,
          payload: response?.headers?.access_token,
        });
      }
      if (response?.headers?.refresh_token) {
        store.dispatch({
          type: SET_AUTH_REFRESH_TOKEN,
          payload: response?.headers?.refresh_token,
        });
      }
      if (CONFIG.ENCRYPT_ENABLE) {
        if (encryptionNotReqd) {
          return response;
        } else {
          await _sodium.ready;
          const Sodium = _sodium;
          const uint8arrayText = await Sodium.crypto_box_open_easy_afternm(
            Sodium.from_hex(response.data.message),
            Sodium.from_base64(
              response.data.nonce,
              Sodium.base64_variants.ORIGINAL
            ),
            app.sharedKey,
            "uint8array"
          );
          const plainText = Buffer.from(uint8arrayText, "hex").toString(
            "base64"
          );
          console.log("Request", JSON.parse(base64.decode(plainText)));
          return {
            status: response.status,
            data: JSON.parse(base64.decode(plainText)),
          };
        }
      } else {
        return response;
      }
    } catch (error) {
      store.dispatch({
        type: SET_SERVICE_LOADER,
        payload: false,
      });
      return Promise.reject(error);
    }
  },
  async (error) => {
    try {
      activeRequests = Math.max(0, activeRequests - 1);
      store.dispatch({
        type: SET_SERVICE_LOADER,
        payload: false,
      });

      let errorObj = {};
      const originalRequest = error.config;
      if (error.response) {
        if (CONFIG.ENCRYPT_ENABLE && !encryptionNotReqd) {
          const { app } = store.getState();
          const hasKey = "nonce" in error.response.data;
          if (hasKey) {
            await _sodium.ready;
            const Sodium = _sodium;
            const uint8arrayText = await Sodium.crypto_box_open_easy_afternm(
              Sodium.from_hex(error.response.data.message),
              Sodium.from_base64(
                error.response.data.nonce,
                Sodium.base64_variants.ORIGINAL
              ),
              app.sharedKey,
              "uint8array"
            );

            const errorText = Buffer.from(uint8arrayText, "hex").toString(
              "base64"
            );
            console.log(JSON.parse(base64.decode(errorText)));

            errorObj = {
              status: error.response.status,
              data: JSON.parse(base64.decode(errorText)),
            };
            let configData = JSON.parse(error.config.data);
            const uint8arrayReqData = await Sodium.crypto_box_open_easy_afternm(
              Sodium.from_hex(configData.message),
              Sodium.from_base64(
                configData.nonce,
                Sodium.base64_variants.ORIGINAL
              ),
              app.sharedKey,
              "uint8array"
            );

            const errorConfigDataText = Buffer.from(
              uint8arrayReqData,
              "hex"
            ).toString("base64");

            console.log(JSON.parse(base64.decode(errorConfigDataText)));
            if (
              JSON.parse(base64.decode(errorConfigDataText)).toString() !==
              "[object FormData]"
            ) {
              originalRequest.data = JSON.parse(
                base64.decode(errorConfigDataText)
              );
            }
          } else {
            errorObj = {
              status: error.response.status,
              data: error.response.data,
            };
            if (error.config.data.toString() !== "[object FormData]") {
              originalRequest.data = JSON.parse(error.config.data);
            }
          }
        } else {
          errorObj = {
            status: error.response.status,
            data: error.response.data,
          };
          if (error.config.data.toString() !== "[object FormData]") {
            originalRequest.data = JSON.parse(error.config.data);
          }
          if (error.config.responseType === "arraybuffer") {
            const enc = new TextDecoder("utf-8");
            const data = new Uint8Array(error.response["data"]);
            errorObj.data = JSON.parse(enc.decode(data));
          }
        }

        if (errorObj.status === 403) {
          if (errorObj?.data?.code === "AGCM-0002") {
            // if (error.config.responseType !== "arraybuffer") {
            //   originalRequest.data = JSON.parse(error.config.data);
            // }
            if (!isRefreshing) {
              isRefreshing = true;
              try {
                const response = await AuthService.kikRefreshToken();
                if (response.status === 200) {
                  error.config.headers[
                    "Authorization"
                  ] = `Bearer ${response.access_token}`;

                  refreshAndRetryQueue.forEach(
                    ({ config, resolve, reject }) => {
                      Axios.request(config)
                        .then((response) => resolve(response))
                        .catch((err) => reject(err));
                    }
                  );
                  refreshAndRetryQueue.length = 0;
                  // originalRequest.data = JSON.parse(error.config.data);
                  return Axios(originalRequest);
                }
              } catch (error) {
                console.log(error);
                store.dispatch({ type: "USER_LOGOUT" });
              } finally {
                isRefreshing = false;
              }
            }
            return new Promise((resolve, reject) => {
              // originalRequest.data = JSON.parse(error.config.data);
              refreshAndRetryQueue.push({
                config: originalRequest,
                resolve,
                reject,
              });
            });
          } else if (errorObj?.data?.code === "AGCM-0004") {
            store.dispatch({ type: "USER_LOGOUT" });
          } else {
            store.dispatch({ type: "USER_LOGOUT" });
            // await AuthService.generateKey();
            store.dispatch({
              type: SET_ERROR_MESSAGE,
              payload: {
                ...errorObj,
                message: "Session Expired. Please try to login again",
              },
            });
            return;
          }
        } else {
          store.dispatch({
            type: SET_ERROR_MESSAGE,
            payload: errorObj,
          });
        }
      } else {
        if (error.code === "ERR_NETWORK") {
          errorObj = {
            data: {
              ...error,
              message:
                "Please check your internet connection" ||
                "Session Expired. Please try to login again",
            },
          };
          store.dispatch({ type: "USER_LOGOUT" });
          store.dispatch({
            type: SET_ERROR_MESSAGE,
            payload: {
              ...errorObj,
            },
          });
        } else {
          console.log(error);
          store.dispatch({ type: "USER_LOGOUT" });
          store.dispatch({
            type: SET_ERROR_MESSAGE,
            payload: {
              code: "Network Error",
              message:
                "The server is not reachable. Please try after some time.",
              errors: null,
            },
          });
        }
      }
      return Promise.reject(errorObj || error.request || error.message);
    } catch (error) {
      store.dispatch({
        type: SET_SERVICE_LOADER,
        payload: false,
      });
      return Promise.reject(error);
    }
  }
);

export default Axios;
